import { render, staticRenderFns } from "./ModalAddDisease.vue?vue&type=template&id=c6ff3f38&scoped=true"
import script from "./ModalAddDisease.vue?vue&type=script&lang=js"
export * from "./ModalAddDisease.vue?vue&type=script&lang=js"
import style0 from "./ModalAddDisease.vue?vue&type=style&index=0&id=c6ff3f38&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6ff3f38",
  null
  
)

export default component.exports